import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'viega-logo',
    templateUrl: './viega-logo.component.html',
    styleUrls: ['./viega-logo.component.scss'],
})
export class ViegaLogoComponent {
    @Input()
    public imgUrl = require("./img/viega-logo.svg");
}



// WEBPACK FOOTER //
// ./src/viega-common/components/viega-logo/viega-logo.component.ts